import { render } from "./CCETestView.vue?vue&type=template&id=b280370c"
import script from "./CCETestView.vue?vue&type=script&lang=js"
export * from "./CCETestView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__